<template>
  <van-cell class="my_cell">
    <div class="my_cell_box">
      <div class="my_cell_label">{{ label }}</div>
      <div class="my_cell_content">{{ content }}</div>
    </div>
  </van-cell>
</template>

<script>
import { Cell } from 'vant'
import './ModifyCell.less'
export default {
  name: 'ModifyCell',
  props: ['label', 'content'],
  components: {
    'van-cell': Cell
  }
}
</script>

<style>
</style>